import {ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import {VehiclesHandlerService} from '../../../api-handlers/vehicles-handler.service';
import {Vehicle} from '../../../models/vehicle';
import {Refill} from '../../../models/refill';
import {AuthService} from '../../../auth-n-routing/auth-service.service';
import {DateHandlerService} from '../../../commons/date-handler.service';
import {SnackBarHandlerService} from '../../../commons/snack-bar-handler.service';
import {TravelsHandlerService} from '../../../api-handlers/travels-handler.service';
import {Travel} from '../../../models/travel';
import {Motivation} from '../../../models/travel-motivation';
import {User} from '../../../models/user';
import {Park} from '../../../models/park';
import {ParksHandlerService} from '../../../api-handlers/parks-handler.service';
import {Itinerario} from '../../../models/itinerario';
import * as _ from 'lodash';

@Component({
	selector: 'app-add',
	templateUrl: './add.component.html',
	styleUrls: ['./add.component.scss']
})
export class AddComponent implements OnInit {
	// @ViewChild('videoRecElement') videoRecElement: any;
	// @ViewChild('videoBoxElement') videoBoxElement: any;
	@Output() isLoading = new EventEmitter<boolean>();
	// @Output() refillAdded = new EventEmitter<boolean>();
	@Output() travelStarted = new EventEmitter<boolean>();
	// @Output() travelEnded = new EventEmitter<boolean>();

	travel: Travel = new Travel(undefined);
	selected_entity: any;
	refill: Refill = new Refill(undefined);
	parks: Park[];
	vehicles_can_drive: Vehicle[] = [];
	travelMotivations: Motivation[] = [];
	selectedMotivation: Motivation;
	roundtrip: boolean = true;
	itinerario: Itinerario[] = [
		{
		  da: '',
		  a: '',
		  ar: true
		},
	  ];

	fromMinDate: Date;
	toMinDate: Date;
	maxDate: Date;

	dom_elements = {
		refresh_is_running: false,
		load_on_init: false,
		first_played: false,
		second_played: false,
		displayControls: false,
		recive_url64: '',
		box_url64: '',
		is_loading : false,
		active_step: 0,
		available_steps: [0],

		visible_parks: [],
		show_can_drive: false,

		addRefuel: {
			is_running: false,
			txt_run: 'SALVATAGGIO IN CORSO...',
			txt_not_run: 'SALVA RIFORNIMENTO'
		},

		startTrip: {
			is_running: false,
			txt_run: 'CREAZIONE VIAGGIO IN CORSO...',
			txt_not_run: 'INIZIA VIAGGIO'
		},

		endTrip: {
			is_running: false,
			txt_run: 'CHIUSURA VIAGGIO IN CORSO...',
			txt_not_run: 'TERMINA VIAGGIO'
		},

		askTrip: {
			is_running: false,
			txt_run: 'INVIO RICHIESTA IN CORSO...',
			txt_not_run: 'RICHIEDI AUTOVETTURA'
		},

		cancelTrip: {
			is_running: false,
			txt_run: 'CANCELLAZIONE RICHIESTA IN CORSO...',
			txt_not_run: 'ANNULLA RICHIESTA'
		}
	};

	constructor(public parksService: ParksHandlerService,
				public vehicleService: VehiclesHandlerService,
				public travelsService: TravelsHandlerService,
				public dateHandlerService: DateHandlerService,
				public snackBarHandler: SnackBarHandlerService,
				public authService: AuthService,
				private router: Router,
				private changeDetector: ChangeDetectorRef,
				private zone: NgZone) {


		this.fromMinDate = new Date();
		this.toMinDate = new Date();
		this.maxDate = new Date();
		this.fromMinDate.setDate(this.fromMinDate.getDate());
		this.toMinDate.setDate(this.fromMinDate.getDate());
		this.maxDate.setDate(this.maxDate.getDate() + 30);
	}

	ngOnInit() {
		this.authService.authChange.subscribe((u: User) => {
			if (u) {
				this.reload();

				this.parksService.getAllParks().then((data: Park[]) => {
					this.parks = data;
          this.parks = _.sortBy(this.parks,["name"]);
					this.dom_elements.visible_parks = this.parks.filter((park) => {
						return park.type_id === '4';
					});
					if (this.dom_elements.visible_parks.length > 0) {
						this.selected_entity = this.dom_elements.visible_parks[0];
					}
				});

				this.vehicleService.getVehicleUserCanDrive().then((vehicles: Vehicle[]) => {
					this.vehicles_can_drive = vehicles;
					this.changeDetector.detectChanges();
				});

				this.travelsService.getTravelMotivations().then((motivationsRes: Motivation[]) => {
					this.travelMotivations = motivationsRes;
					this.changeDetector.detectChanges();
				});
			}
		});
	}

	onFromDateChange (event) {
		if (event) {
			this.toMinDate = event;
			this.travel.required_to = null;
		}
	}

	onMotivationChange(event){
		this.travel.motivation = this.selectedMotivation.id;
		this.travel.motivation_name = this.selectedMotivation.name;

		if (this.selectedMotivation.name !== 'Altro') {
			this.travel.motivation_other = '';
		}
	}

	isItinerarioValid(): boolean {
		let validity = true;
		
		this.itinerario.forEach((item) => {
			if (item.da.length === 0 || item.a.length === 0) {
				validity = false;
			}
		});

		return validity;
	}

	parkChanged($event) {
		this.selected_entity = null;
		if ($event.target.value === '1') {
			this.dom_elements.show_can_drive = false;

			this.dom_elements.visible_parks = this.parks.filter((park) => {
				return park.type_id === '4';
			});
			if (this.dom_elements.visible_parks.length > 0) {
				this.selected_entity = this.dom_elements.visible_parks[0];
			}

		} else if ($event.target.value === '2') {
			this.dom_elements.show_can_drive = false;

			this.dom_elements.visible_parks = this.parks.filter((park) => {
				return park.type_id === '1';
			});
			if (this.dom_elements.visible_parks.length > 0) {
				this.selected_entity = this.dom_elements.visible_parks[0];
			}

		} else if ($event.target.value === '3') {
			this.dom_elements.show_can_drive = false;

			this.dom_elements.visible_parks = this.parks.filter((park) => {
				return park.type_id === '2';
			});
			if (this.dom_elements.visible_parks.length > 0) {
				this.selected_entity = this.dom_elements.visible_parks[0];
			}

		} else if ($event.target.value === '4') {
			this.dom_elements.show_can_drive = false;

			this.dom_elements.visible_parks = this.parks.filter((park) => {
				return park.type_id === '3';
			});
			if (this.dom_elements.visible_parks.length > 0) {
				this.selected_entity = this.dom_elements.visible_parks[0];
			}

		} else if ($event.target.value === '5') {
			this.dom_elements.show_can_drive = true;
			if (this.vehicles_can_drive.length > 0) {
				this.selected_entity = this.vehicles_can_drive[0];
			}
		}
	}

	reload() {
		this.travel.user = this.authService.getAuthenticatedUser();
		this.selected_entity = null;
		console.log('reload');
	}

	addEnter() {
		// "Parte relativa all'uso della telecamera rimossa"
	}

	addLeave() {
		// "Parte relativa all'uso della telecamera rimossa"
	}


	isRequestTravelComplete(): boolean {
		let isComplete = false;

		if (!this.isItinerarioValid()) {
			this.snackBarHandler.showSnackbar('Impostare itinerario valido', 3000);
		} else if (!this.selected_entity || (!this.selected_entity.name && !this.selected_entity.plate)) {
			this.snackBarHandler.showSnackbar('Impostare un parco mezzi valido', 3000);
		} else if (!this.travel.motivation || this.travel.motivation === -1) {
			this.snackBarHandler.showSnackbar('Impostare la motivazione del viaggio', 3000);
		} else if (!this.travel.required_from) {
			this.snackBarHandler.showSnackbar('Impostare data di inizio richiesta', 3000);
		} else if (!this.travel.required_to) {
			this.snackBarHandler.showSnackbar('Impostare data di fine richiesta', 3000);
		} else if (this.travel.required_from > this.travel.required_to) {
			this.snackBarHandler.showSnackbar('Data inizio maggiore di data fine', 3000);
		} else {
			isComplete = true;
		}/*else if (!this.email_responsabile) {
			this.snackBarHandler.showSnackbar('Impostare l\'email del responsabile gerarchico', 3000);
		} */

		return isComplete;
	}


	requestTravel() {
		this.dom_elements.askTrip.is_running = true;
		let vehicle_id = '0';
		let park_id = '0';

		if (this.selected_entity instanceof Vehicle) {
			vehicle_id = this.selected_entity.id.toString();
			park_id = this.selected_entity.park.id.toString();
		} else if (this.selected_entity instanceof Park) {
			park_id = this.selected_entity.id.toString();
		}

		if (this.isRequestTravelComplete()) {
			this.travel.route = JSON.stringify(this.itinerario);
			this.travel.route_modified = false;

			this.travelsService.addTravel(this.travel, park_id, vehicle_id).then((travel: Travel) => {
				this.travel = travel;
				this.travelStarted.next(undefined);
				this.reload();
				this.cleanTravelField();
				this.router.navigate(['./dashboard/travels']);

			}, (err) => {
				/*this.snackBarHandler.showSnackbar('Attenzione creazione viaggio fallita, ' +
					'verifica se esiste già un viaggio aperto e che la mail sia corretta. Ricarica la pagina.', 3000);*/
				this.snackBarHandler.showSnackbar(err, 3000); // Messaggio dal backend
				console.log(err);
			}).catch().then(() => {
				this.dom_elements.askTrip.is_running = false;
			});
		} else {
			this.dom_elements.askTrip.is_running = false;
		}

	}
	cleanTravelField() {
		console.log('cleanTravelField');
		this.travel = new Travel(undefined);
		this.selected_entity = '';
		this.reload();
	}

}
